<template>
<div class='grid-wrap'>
    <dx-data-grid ref='refCompanyGrid'
      :data-source='dataSource'
      :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
      :hover-state-enabled = "true" :allowColumnResizing = 'true'
      column-resizing-mode = 'widget' :allow-column-reordering = "true"
      :height="gridHeight" :row-alternation-enabled="true"
      keyExpr="seqId" :focusedRowEnabled="true"
      @toolbarPreparing="onToolbarPreparing"
      @rowDblClick="onRowDblClick"
    >
      <DxSearchPanel
        :visible="true"
        placeholder="검색..."
      />
      <DxFilterRow
        :visible="false"
        apply-filter="auto"
      />

      <DxColumnFixing :enabled="true"/>
      <DxColumn
      :allowEditing="false"
      :visible="false"
      caption="고객사코드"
      data-field="고객사코드"
      :min-width="100"
      alignment="center"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="고객사명"
      data-field="고객사명"
      :min-width="180"
      sort-order="asc"
      :fixed="true"
      >

      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="담당컨설턴트"
      data-field="컨설턴트"
      alignment="center"
      :min-width="100"
      >

        <DxLookup
          :data-source="employeeInfo"
          display-expr="성명"
          value-expr="사번"
        />
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="회사규모"
      data-field="회사규모"
      alignment="center"
      :min-width="100"
      >
        <DxLookup
          :data-source="companyTypeLookup"
          display-expr="코드명"
          value-expr="코드명"
        />

      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="상장"
      data-field="상장여부"
      alignment="center"
      :min-width="60"
      >
        <DxLookup
          :data-source="openLookup"
          display-expr="코드명"
          value-expr="코드명"
        />

      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="사업자번호"
      data-field="사업자번호"
      alignment="center"
      :min-width="100"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="업종"
      data-field="업종"
      alignment="center"
      :min-width="100"
      >

      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="자본금(억)"
      data-field="자본금"
      format="#,##0"
      dataType="number"
      :min-width="100"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="연매출액(억)"
      data-field="연간매출액"
      format="#,##0"
      dataType="number"
      :min-width="100"
      >

      </DxColumn>
      <DxColumn
        :allowEditing="true"
        :visible="true"
        caption="직원수"
        data-field="종업원수"
        format="#,##0"
        dataType="number"
        :min-width="80"
      >

      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="isExporing"
      caption="본사주소"
      data-field="본사주소"
      :min-width="100"
      >

      </DxColumn>

      <DxColumn
      :allowEditing="true"
      :visible="isExporing"
      caption="고객사소개"
      data-field="고객사소개"
      :min-width="100"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="isExporing"
      caption="홈페이지"
      data-field="홈페이지"
      :min-width="100"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="계약단계"
      data-field="계약단계"
      alignment="center"
      :min-width="90"
      >

        <DxLookup
          :data-source="contractLookup"
          display-expr="코드명"
          value-expr="코드명"
        />
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="유치경로"
      data-field="유치경로"
      alignment="center"
      :min-width="100"
      >
        <DxLookup
          :data-source="infoLookup"
          display-expr="코드명"
          value-expr="코드명"
        />
      </DxColumn>

      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="평균수수료율"
      data-field="평균수수료"
      format="#,##0.0%"
      dataType="number"
      :min-width="90"
      >

      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="isExporing"
      caption="담당자성명"
      data-field="담당자성명"
      alignment="center"
      :min-width="100"
      >

      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="isExporing"
      caption="담당자부서"
      data-field="담당자부서"
      alignment="center"
      :min-width="100"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="isExporing"
      caption="담당자직급"
      data-field="담당자직급"
      alignment="center"
      :min-width="100"
      :allowExporting="true"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="isExporing"
      caption="연락처"
      data-field="연락처"
      :min-width="110"
      :allowExporting="true"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="isExporing"
      caption="휴대폰"
      data-field="휴대폰"
      :min-width="110"
      >

      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="isExporing"
      caption="이메일"
      data-field="이메일"
      :min-width="130"
      >

      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="작성자"
      data-field="createdName"
      alignment="center"
      :min-width="80"
      >
        <DxLookup
          :data-source="employeeInfo"
          display-expr="성명"
          value-expr="사번"
        />
      </DxColumn>

      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="등록일"
      format="yyyy-MM-dd"
      data-field="createdTime"
      alignment="center"
      dataType="date"
      :min-width="90"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="수정자"
      data-field="updatedId"
      alignment="center"
      :min-width="80"
      >
        <DxLookup
          :data-source="employeeInfo"
          display-expr="성명"
          value-expr="사번"
        />
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="수정일"
      data-field="updatedTime"
      alignment="center"
      format="yyyy-MM-dd"
      dataType="date"
      :min-width="90"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="isExporing"
      caption="사용유무"
      data-field="사용유무"
      :min-width="100"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="isExporing"
      caption="삭제유무"
      data-field="삭제유무"
      :min-width="100"
      >
      </DxColumn>
      <dx-paging :enabled="false"/>
      <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
      <dx-sorting mode="multiple"/>
    </dx-data-grid>
  </div>
</template>

<script>
import ConstDef from '../../share/ConstDef'
import DxDataGrid, { DxScrolling, DxFilterRow, DxColumnFixing,
  DxColumn, DxPaging, DxSorting, DxSearchPanel, DxLookup
} from 'devextreme-vue/data-grid'

export default {
  name: 'customerSummartComponent',
  data: function () {
    return {
      dataSource: null,
      isExporing: false,
      gridHeight: null,
      openLookup: ConstDef.YN_LOOKUP,
      infoLookup: this.$store.getters.getBaseDataByType(ConstDef.유치경로),
      contractLookup: this.$store.getters.getBaseDataByType(ConstDef.계약단계),
      companyTypeLookup: this.$store.getters.getBaseDataByType(ConstDef.회사규모),
      employeeInfo: this.$store.getters.getEmployee
    }
  },
  components: {
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxColumnFixing,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxLookup
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
    this.refreshDataSource()
  },
  mounted () {
    this.gridHeight = (screen.height - 320) / 3
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onRowDblClick (e) {
      this.$router.push(`/main/customerSearch?seqId=${e.data.seqId}`)
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;'><b><span style="color:black;font-size:1.2rem;">&#10016;</span> 고객사 정보</b></div>`
          }
        }
      )
    },
    refreshDataSource () {
      this.$_sp.runFindProc('spFindAllCustomerLimit', { limit: 10 })
        .then(data => {
          this.dataSource = this.$_sp.MakeModel(data)
        })
        .catch(error => {
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">

</style>
